import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Image from '../Image';
import Editor from '../../img/goran_eic.png'


function Contact({title}) {

    useEffect(() => {
          document.title = title;
    }, [title]);
    

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                   Contact Us
                </h2>

                <hr className="instructions_hr"/>


                <p className='contact_content'>
                  If you have any questions about publishing an article, you can find all the details on the <Link className='contact_instructions' to="/instructions">Instructions page</Link>. For any additional inquiries, feel free to contact our Editor-in-Chief directly.
                </p>

                <div className='cotact_editor'>

                    <div className='contact_editor_img_block'>
                      <Image
                          src={Editor}
                          alt="Goran belojevic - Editor-in-Chief"
                          class="contact_editor_image"  
                      />
                    </div>
                    <div className='contact_editor_content_block'>

                        <h4 className='contact_editor_content_block_title'>
                          Editor-in-Chief
                        </h4>

                        <p className='contact_editor_content_block_name'>
                          Prof. Dr. Goran Belojević, MD, PhD
                        </p>

                        <p>
                          <strong>Email:</strong> <a className='contact_email_link' href="mailto:goran.belojevic1956@gmail.com">goran.belojevic1956@gmail.com</a>
                        </p>

                    </div>
                    

                </div>

            </div>
        </div>
      </>
    );
}

export default Contact;